import React from "react";

function ContactUs() {
  return (
    <div className="flex overflow-hidden flex-col justify-center py-20 bg-[#F9FAFB]">
      <div className="flex justify-center items-center px-32 py-16 max-md:px-5">
        <div className="flex overflow-hidden flex-wrap self-stretch my-auto rounded-2xl border border border-solid min-w-[240px] w-[1200px]">
          <div className="flex flex-col min-w-[240px] w-[400px] max-[768px]:w-full">
            <div className="flex relative flex-col w-full h-full pt-[520px] max-md:pt-24">
              <img
                loading="lazy"
                srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/d50de909c81ad424c4f176d53730b3ac0dc9c0b0244caed6f3a6e3579119c54f?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                className="object-cover absolute inset-0 size-full"
                alt="Company Cover"
              />
              <div className="flex relative flex-col justify-center px-4 py-6 min-h-[107px] max-sm:mt-auto max-sm:w-full max-sm:min-h-[349px]">
                <div className="text-base font-bold text-gray-50">Office</div>
                <div className="mt-2 text-xs text-gray-100">
                  Ground Floor, 470 Street, Kilda Road
                  <br />
                  Melbourne VICTORIA 3004 Australia
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col flex-1 shrink p-8 my-auto bg-white rounded-none shadow-xl basis-0 min-w-[240px] max-md:px-5 max-md:max-w-full">
            <div className="flex flex-col justify-center items-start w-full text-center max-md:max-w-full">
              <div className="text-4xl font-bold text-gray-800">Contact Us</div>
              <div className="self-stretch mt-2 w-full text-base text-left text-gray-500 max-md:max-w-full">
                Bringing Credibility, Integrity, and Protection to Software
                Developers and Clients Worldwide
              </div>
            </div>
            <div className="flex flex-col mt-16 w-full max-md:mt-10 max-md:max-w-full">
              <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                <div className="relative flex flex-col flex-1 shrink basis-0 min-w-[240px]">
                  <label className="text-xs font-medium text-gray-600">First Name</label>
                  <div className="flex items-center border border-gray-400 rounded-lg mt-1">
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/81909defc6490ba1bd06f3ee697a54b3b75ca0847b78f19c19b27bb1970f3f18?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                      className="absolute left-4 w-5 h-5"
                      alt="First Name Icon"
                    />
                    <input
                      type="text"
                      placeholder="e.g. John"
                      className="pl-12 w-full rounded-lg border-0 py-3 text-base text-gray-400"
                    />
                  </div>
                </div>
                <div className="relative flex flex-col flex-1 shrink basis-0 min-w-[240px]">
                  <label className="text-xs font-medium text-gray-600">Last Name</label>
                  <div className="flex items-center border border-gray-400 rounded-lg mt-1">
                    <img
                      loading="lazy"
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/81909defc6490ba1bd06f3ee697a54b3b75ca0847b78f19c19b27bb1970f3f18?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                      className="absolute left-4 w-5 h-5"
                      alt="Last Name Icon"
                    />
                    <input
                      type="text"
                      placeholder="e.g. Dowry"
                      className="pl-12 w-full rounded-lg border-0 py-3 text-base text-gray-400"
                    />
                  </div>
                </div>
              </div>
              <div className="relative flex flex-col mt-6 w-full min-h-[64px] max-md:max-w-full">
                <label className="text-xs font-medium text-gray-600">Email</label>
                <div className="flex items-center border border-gray-400 rounded-lg mt-1">
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/96232daf6ea2dae46048c8500a95ba7a6c9cab201b1b4ed8de9311e49ab6c58a?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                    className="absolute left-4 w-5 h-5"
                    alt="Email Icon"
                  />
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="pl-12 w-full rounded-lg border-0 text-base py-3 text-gray-400"
                  />
                </div>
              </div>
              <div className="flex flex-col mt-6 w-full min-h-[179px] max-md:max-w-full">
                <label className="text-xs font-medium text-gray-600">Additional Message</label>
                <textarea
                  placeholder="Type a message here..."
                  className="p-3 mt-1 w-full rounded-lg border h-[160px] border-gray-400 text-base text-gray-400"
                />
              </div>
              <div className="flex flex-wrap gap-10 justify-between items-center mt-6 w-full max-md:max-w-full">
                <div className="flex gap-2 items-center self-stretch my-auto text-sm text-gray-600 border border-gray-300 rounded-lg px-4 py-3">
                  <div className="flex gap-1 items-center self-stretch my-auto w-[145px]">
                    <input type="checkbox" className="flex shrink-0 mr-1 self-stretch my-auto bg-gray-100 rounded border border-gray-400 border-solid" />
                    <div className="self-stretch my-auto">I’m not a robot</div>
                  </div>
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/4f4b4af0b80d27c8b8d07aa7feab6c11ff97c053b8f8bc237359e5a5d3b20698?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                    className="object-contain shrink-0 self-stretch my-auto aspect-[1.04] w-[35px]"
                    alt="Captcha Icon"
                  />
                </div>
                <button onClick={() => alert("Sent")} className="flex gap-1 justify-center items-center self-stretch py-2.5 pr-4 pl-5 my-auto w-40 text-base font-medium text-gray-50 whitespace-nowrap bg-blue-900 rounded-full max-md:w-full">
                  <div className="self-stretch my-auto">Send</div>
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/56612afd96d727269f1b877d704ed990f18689279df13d0675bb94f9d7e7d936?placeholderIfAbsent=true&apiKey=330fc829dca74d1b9d79524f3edd258c"
                    className="object-contain shrink-0 self-stretch my-auto aspect-square w-[15px]"
                    alt="Send Icon"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;